var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup2218(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2218",
    "data-name": "Group 2218",
    transform: "translate(-980.79 -482.79)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1417",
    "data-name": "Ellipse 1417",
    cx: 19,
    cy: 19,
    r: 19,
    transform: "translate(980.79 482.79)",
    fill: "#3181b5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "download-1",
    transform: "translate(990.019 492.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M18.568,228.231a.545.545,0,0,0-.548.548v4.982a2.458,2.458,0,0,1-2.454,2.454H3.55A2.458,2.458,0,0,1,1.1,233.76V228.7a.548.548,0,1,0-1.1,0v5.063a3.554,3.554,0,0,0,3.55,3.55H15.566a3.554,3.554,0,0,0,3.55-3.55v-4.982A.548.548,0,0,0,18.568,228.231Z",
    transform: "translate(0 -219.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M139.871,30.617a.551.551,0,0,0,.385.162.534.534,0,0,0,.385-.162l3.481-3.481a.548.548,0,1,0-.775-.775L140.8,28.909V17.8a.548.548,0,1,0-1.1,0V28.909l-2.548-2.548a.548.548,0,0,0-.775.775Z",
    transform: "translate(-130.699 -17.25)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup2218);
export default __webpack_public_path__ + "static/media/Group 2218.747c3df2cf082a34f43fe36fea7a54ed.svg";
export { ForwardRef as ReactComponent };